import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './dialog';
import { Button } from './button';
import { FileText } from 'lucide-react';

interface NotesModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title?: string;
    notes: string;
}

const NotesModal: React.FC<NotesModalProps> = ({
    open,
    onOpenChange,
    title = 'Notas',
    notes
}) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-lg bg-card border-border">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-3 text-xl font-bold text-foreground">
                        <FileText className="w-5 h-5 text-indigo-600" />
                        {title}
                    </DialogTitle>
                </DialogHeader>

                <div className="py-4 max-h-[60vh] overflow-y-auto pr-1">
                    {notes ? (
                        <DialogDescription className="text-sm whitespace-pre-wrap break-words text-foreground leading-relaxed">
                            {notes}
                        </DialogDescription>
                    ) : (
                        <DialogDescription className="text-sm italic text-muted-foreground">
                            No hay notas disponibles.
                        </DialogDescription>
                    )}
                </div>

                <div className="flex justify-end gap-3">
                    <Button
                        variant="outline"
                        onClick={() => onOpenChange(false)}
                        className="rounded-lg border-input hover:bg-accent text-foreground"
                    >
                        Cerrar
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default NotesModal;
